export default __webpack_public_path__ + "static/media/search.1d97c4fc.svg";